import type { PartnerAddressResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Grid2, Typography } from "@mui/material";
import type { FC } from "react";

const addressResource = Resources.base.partner.detail.addressInfo;
const addressTypeResource = Resources.base.partner.selectOptions.address;

type Props = {
	address: PartnerAddressResponseDto;
};

export const PartnerAddressInfoWidget: FC<Props> = ({ address }) => {
	const { t } = useResource();
	return (
		<BaseCard
			title={`${address.type ? t(addressTypeResource[address.type]) : ""} ${t(addressResource.title)}`}
		>
			<Grid2 container>
				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(addressResource.street)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{address.street}
					</Typography>
				</Grid2>

				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(addressResource.builduingNumber)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{address.buildingNumber}
					</Typography>
				</Grid2>

				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(addressResource.city)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{address.city}
					</Typography>
				</Grid2>

				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(addressResource.postCode)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{address.postCode}
					</Typography>
				</Grid2>

				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(addressResource.country)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{address.country}
					</Typography>
				</Grid2>
			</Grid2>
		</BaseCard>
	);
};
